// Admin API client — /admin/finance/* (mirrors the API's finance aggregate).

import type { PnlSummary, PnlMonthDetail } from '@a7y/types';
import { client } from './transport';

export const financeApi = {
  // Finance P&L (A7Y-2054)
  getPnlSummary: () => client.get<{ data: PnlSummary }>('/finance/pnl/summary'),
  getPnlMonth: (month: string) =>
    client.get<{ data: PnlMonthDetail }>(`/finance/pnl/month/${month}`),
};
